import { render, staticRenderFns } from "./ord_sent.vue?vue&type=template&id=92fe6c0e&scoped=true&"
import script from "./ord_sent.vue?vue&type=script&lang=js&"
export * from "./ord_sent.vue?vue&type=script&lang=js&"
import style0 from "./ord_sent.vue?vue&type=style&index=0&id=92fe6c0e&scoped=true&lang=less&"
import style1 from "./ord_sent.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92fe6c0e",
  null
  
)

export default component.exports